import usePageTracking from "../hooks/usePagetracking";

const PageTracker = () => {
  usePageTracking(); // Hook called inside a valid React component
  return null;
};

export default PageTracker;